// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3Qxso","right":"styles_right__20ZkV"};